export default function UrgencyBanner() {
  return (
    <div
      data-testid="urgency-banner"
      style={{
        backgroundColor: '#5C2424',
        padding: '10px 20px',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          margin: 0,
          fontFamily: 'Graphik, sans-serif',
          fontWeight: 700,
          fontSize: '12px',
          letterSpacing: '0.5px',
          color: '#FAF5EF',
        }}
        data-testid="urgency-banner-text"
      >
        April &amp; May dates are filling fast — only Hyderabad &amp; Telangana for now.
      </p>
    </div>
  );
}
